<template>
  <v-container>
    <v-layout wrap>
      <v-flex xs12 sm6 md6 lg4 fill-height class="pa-1">
        <stat-card v-model="total" :loading="loading">{{ $t('ทั้งหมด') }}</stat-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import StatCard from './../../StatCard'

export default {
  components: {
    StatCard
  },
  props: ['datefrom', 'dateto'],
  data: function () {
    return {
      loading: false,
      total: 0
    }
  },
  mounted: function () {
    var vm = this
    vm.$store.dispatch('loadLinePushMessageCount', { datefrom: vm.datefrom, dateto: vm.dateto })
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/dashboard/customize/uu/UuBroadcastStat.vue